import { z } from 'zod';
import { IncludeTestWorkspacesQuerySchema } from './test-workspaces.schemas';
import { OperatingModelSchema, SetupStatusSchema } from '../identity/organizations.schemas';

export const AdminOrganizationListItemSchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
  type: z.enum(['main', 'subsidiary']),
  workspaceId: z.uuid(),
  workspaceName: z.string().min(1),
  // Whether the Standort's workspace is a testing environment (IMM-593.2).
  isTest: z.boolean(),
  // The Standort's Einrichtungsstatus — the operator list filters by it (IMM-1075).
  setupStatus: SetupStatusSchema,
  createdAt: z.iso.datetime(),
});

export type AdminOrganizationListItem = z.infer<typeof AdminOrganizationListItemSchema>;

export const ListAdminOrganizationsResponseSchema = z.object({
  data: z.array(AdminOrganizationListItemSchema),
});

export type ListAdminOrganizationsResponse = z.infer<typeof ListAdminOrganizationsResponseSchema>;

export const ListAdminOrganizationsQuerySchema = IncludeTestWorkspacesQuerySchema.extend({
  workspaceId: z.uuid().optional(),
});

export type ListAdminOrganizationsQuery = z.infer<typeof ListAdminOrganizationsQuerySchema>;

export const GetAdminOrganizationPathParamsSchema = z.object({
  id: z.uuid(),
});

export const GetAdminOrganizationResponseSchema = AdminOrganizationListItemSchema.extend({
  address: z.object({
    street: z.string(),
    houseNumber: z.string(),
    postalCode: z.string(),
    city: z.string(),
    country: z.string(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
  }),
  operatingModel: OperatingModelSchema,
  internalWebsite: z.string().nullable(),
  companyId: z.uuid().nullable(),
});

export type GetAdminOrganizationResponse = z.infer<typeof GetAdminOrganizationResponseSchema>;

export const UpdateAdminOrganizationAddressBodySchema = z.object({
  address: z.object({
    street: z.string().trim().min(1).max(100),
    houseNumber: z.string().trim().min(1).max(20),
    postalCode: z
      .string()
      .trim()
      .regex(/^\d{5}$/),
    city: z.string().trim().min(1).max(80),
    country: z.string().trim().min(1).max(80),
    latitude: z.number().min(-90).max(90).nullable().default(null),
    longitude: z.number().min(-180).max(180).nullable().default(null),
  }),
});

export type UpdateAdminOrganizationAddressBody = z.infer<typeof UpdateAdminOrganizationAddressBodySchema>;

export const UpdateAdminOrganizationAddressPathParamsSchema = z.object({
  id: z.uuid(),
});

export const UpdateAdminOrganizationAddressResponseSchema = GetAdminOrganizationResponseSchema;

export type UpdateAdminOrganizationAddressResponse = z.infer<typeof UpdateAdminOrganizationAddressResponseSchema>;

export const UpdateAdminOrganizationNameBodySchema = z.object({
  name: z.string().trim().min(1).max(80),
});

export type UpdateAdminOrganizationNameBody = z.infer<typeof UpdateAdminOrganizationNameBodySchema>;

export const UpdateAdminOrganizationNamePathParamsSchema = z.object({
  id: z.uuid(),
});

export const UpdateAdminOrganizationNameResponseSchema = GetAdminOrganizationResponseSchema;

export type UpdateAdminOrganizationNameResponse = z.infer<typeof UpdateAdminOrganizationNameResponseSchema>;
